import { PaceEnvironment } from '@evorait/pace-environment';

export const environment: PaceEnvironment = {
    production: true,
    operateInMockMode: false,
    appId: 'com.siemens.medical.solutions.usa.paceFormsFI',
    apiBase: 'https://pace-non-prod-backend-qng101-partners.azurewebsites.net',
    apiSapProxy: 'api/proxy',
    reportIssueSupportEmail: 'healthcaretest@service-now.com',
    bundleIdentifierName: 'PACE forms for Factory Installation',
    subscribeNotificationsOverride: 'https://pace-non-prod-backend-qng101-partners.azurewebsites.net', // No trailing slash
    subscriptionServerPublicKey:
        'BGXPTVy72unf7at8QszwD9YXjraFD5JEIS5lpi4q8T46hSTCcZy2fOrfrKBn2kPt4QvlQ28fk2LEAzbyTo3TAPQ',
    complaintsLinkPath: 'api/ComplaintsLink',
    /* msal: {
        clientId: '406b858f-fead-4e6c-8390-631f25df3125',
        authority: 'https://login.microsoftonline.com/5dbf1add-202a-4b8d-815b-bf0fb024e033',
        fxAppScope: 'api://00ba6061-87f2-48d8-954d-18aa8003f88e/user_impersonation',
        btpApimScope: 'api://20a1d762-b6cc-4fb8-a343-04087124cc93/read',
        graphApiUrl: 'https://graph.microsoft.com/v1.0/me',
    },*/
    auth0: {
        domain: 'shs.login.siemens-healthineers.com',
        clientId: 'kWjWnJw8R6u97GUjl9zoWdt4SZhfF7li',
        authorizationParams: {
            audience: 'api://kWjWnJw8R6u97GUjl9zoWdt4SZhfF7li/user_impersonation',
            response_type: 'code',
            scope: 'openid profile email',
            redirect_uri: window.location.origin,
        },
        errorPath: '/error',
        cacheLocation: 'localstorage',
        useRefreshTokens: true,
    },
};
